export default import.meta.ROLLUP_FILE_URL_eIA3vOtkaC1SiQXYfamlbA